import React from "react";
import Plot from 'react-plotly.js';

function TraitLocPlot(props) {
    if (props.data === null) {
        return (
            <div className="card my-3 mx-3">
                <div className="card-body d-flex align-items-center justify-content-center">
                    Failed to create visualization
                </div>
            </div>
        )
    }
    else {
        const plotDict = {};
        props.data.forEach(record => {
            if (record[props.trait]) {
                if (plotDict[record.LOC] === undefined) {
                    plotDict[record.LOC] = {
                        y: [],
                        type: 'box',
                        name: record.LOC
                    }
                }

                plotDict[record.LOC].y.push(record[props.trait]);
            }
        });
        const plotData = Object.values(plotDict);


        return (
            <Plot
                data={plotData}
                layout={{ title: `Distribution of ${props.trait} Across Locations`, xaxis: { title: 'Location' }, yaxis: { title: `${props.trait}` }, width: props.width, height: props.height }}
            />
        )
    }
}

export default TraitLocPlot;